import { useInsertionEffect } from 'react'

export default (lock, originalStyle) => {
  useInsertionEffect(() => {
    const isClient = !(typeof window === 'undefined')
    if(isClient && lock){
      document.body.style.overflow = 'hidden'
    }
    return isClient ? () => document.body.style.overflow = originalStyle : () => null

  }, [lock])
}